(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lux-best-sellers"] && !Shopify.designMode) return;
  try {
    
(function () {
  function init(root) {
    if (root.dataset.stlReady) return;
    root.dataset.stlReady = '1';
    var track = root.querySelector('.stl__track');
    var cards = [].slice.call(root.querySelectorAll('.stl__card'));
    var prev = root.querySelector('.stl__arrow--prev');
    var next = root.querySelector('.stl__arrow--next');
    var dotsWrap = root.querySelector('.stl__dots');
    if (!track || !cards.length) return;

    function step() {
      var gap = parseFloat(getComputedStyle(track).columnGap) || 0;
      return cards[0].getBoundingClientRect().width + gap;
    }
    function go(dir) { track.scrollBy({ left: dir * step(), behavior: 'smooth' }); }
    prev && prev.addEventListener('click', function () { go(-1); });
    next && next.addEventListener('click', function () { go(1); });

    cards.forEach(function (_, i) {
      var b = document.createElement('button');
      b.type = 'button'; b.className = 'stl__dot'; b.setAttribute('aria-label', 'Go to card ' + (i + 1));
      b.addEventListener('click', function () { track.scrollTo({ left: i * step(), behavior: 'smooth' }); });
      dotsWrap.appendChild(b);
    });
    var dots = dotsWrap.querySelectorAll('.stl__dot');

    function update() {
      var i = Math.round(track.scrollLeft / step());
      dots.forEach(function (d, n) { d.classList.toggle('is-active', n === i); });
      if (prev) prev.disabled = track.scrollLeft <= 2;
      if (next) next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 2;
    }
    track.addEventListener('scroll', function () { requestAnimationFrame(update); }, { passive: true });
    window.addEventListener('resize', update);
    update();

    /* Play reels only while visible */
    var videos = root.querySelectorAll('video.stl__video');
    if ('IntersectionObserver' in window && root.dataset.autoplay === 'true') {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          var v = e.target;
          if (e.isIntersecting) { v.preload = 'auto'; var p = v.play(); if (p && p.catch) p.catch(function () {}); }
          else v.pause();
        });
      }, { root: track, threshold: 0.6 });
      videos.forEach(function (v) { io.observe(v); });
    }

    /* Sound toggle - one card unmuted at a time */
    root.querySelectorAll('.stl__sound').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault(); e.stopPropagation();
        var v = btn.closest('.stl__card').querySelector('video');
        if (!v) return;
        var on = v.muted;
        root.querySelectorAll('video').forEach(function (o) { o.muted = true; });
        root.querySelectorAll('.stl__sound').forEach(function (s) { s.setAttribute('aria-pressed', 'false'); });
        if (on) { v.muted = false; btn.setAttribute('aria-pressed', 'true'); }
      });
    });

    /* Quick-buy sheet */
    function setOpen(card, open) {
      card.classList.toggle('is-open', open);
      var up = card.querySelector('.stl__up'), sh = card.querySelector('.stl__sheet');
      up && up.setAttribute('aria-expanded', open);
      sh && sh.setAttribute('aria-hidden', !open);
    }
    cards.forEach(function (card) {
      var up = card.querySelector('.stl__up');
      var close = card.querySelector('.stl__close');
      var atc = card.querySelector('.stl__atc');
      up && up.addEventListener('click', function () {
        cards.forEach(function (c) { if (c !== card) setOpen(c, false); });
        setOpen(card, !card.classList.contains('is-open'));
      });
      close && close.addEventListener('click', function () { setOpen(card, false); });
      atc && atc.addEventListener('click', function () {
        var sel = card.querySelector('.stl__variant');
        if (!sel || !sel.value) return;
        var label = atc.textContent;
        atc.disabled = true; atc.textContent = 'Adding...';
        fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: [{ id: parseInt(sel.value, 10), quantity: 1 }] })
        }).then(function (r) { if (!r.ok) throw new Error('add failed'); return r.json(); })
          .then(function () {
            atc.textContent = 'Added \u2713';
            document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
            document.documentElement.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true }));
            setTimeout(function () { atc.textContent = label; atc.disabled = false; setOpen(card, false); }, 1400);
          })
          .catch(function () {
            atc.textContent = 'Could not add - try again';
            setTimeout(function () { atc.textContent = label; atc.disabled = false; }, 1800);
          });
      });
    });
  }
  function boot() { document.querySelectorAll('.stl').forEach(init); }
  document.addEventListener('DOMContentLoaded', boot);
  document.addEventListener('shopify:section:load', boot);
  boot();
})();

  } catch(e) { console.error(e); }
})();
})();
